import { Injectable } from "@angular/core";

import IGuid = System.IGuid;

@Injectable({providedIn: 'root'})
export class CropUtilV2CrService {
    public getMostFequentCropId<T extends {FarmCropId?: IGuid}>(data: T[]): T['FarmCropId'] | undefined {
        if (!data || data.length === 0) {
            return undefined;
        }

        const counts = new Map<string, { id: T['FarmCropId']; count: number }>();
        let maxEntry: { id: T['FarmCropId']; count: number } | undefined;

        for (const d of data) {
            const id = d?.FarmCropId;
            if (id == null) {
                continue;
            }

            const key = id.toString();
            const current = counts.get(key) ?? { id, count: 0 };
            current.count++;
            counts.set(key, current);

            if (!maxEntry || current.count > maxEntry.count) {
                maxEntry = current;
            }
        }

        return maxEntry?.id;
    }
}